import { render, staticRenderFns } from "./registAuth.vue?vue&type=template&id=5d8ba074&"
import script from "./registAuth.vue?vue&type=script&lang=js&"
export * from "./registAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports